import { getEnumValues } from '#app/utils/enumUtils';

import { ControllerDetails } from './ControllerDetails';

export enum IterationStatusCode {
  CREATED = 'CREATED',
  CANCELLED = 'CANCELLED',
  VALIDATED = 'VALIDATED',
  REJECTED = 'REJECTED',
}

export enum LineOfBusiness {
  TCI = 'TCI',
  SURETY = 'SURETY',
  FIDELITY = 'FIDELITY',
}

export const linesOfBusiness: LineOfBusiness[] = getEnumValues(LineOfBusiness);

export interface SupportRequestData {
  customerActivityDescription: string;
  sensitiveBusinessSector?: string;
}

export interface ReputationalRiskData {
  quizFormValue: {
    controversial: string;
    alert: string;
    search: string;
    guideline: string;
  };
  riskFormValue: {
    averageRiskScore: string;
    email?: string;
    comment?: string;
  };
  documentIds?: string[];
}

export interface VettingIteration {
  iterationId: string;
  lineOfBusiness: LineOfBusiness;
  statusCode: IterationStatusCode;
  companyId: string;
  businessUnitCode?: string;
  creation: {
    creatorId: string;
    creationDateTime: string;
    ownerId: string;
  };
  closure?: {
    requestorId: string;
    closureDateTime: string;
  };
  controls: ControllerDetails[];
  documentIds?: string[];
  customProperties: {
    supportTicketId?: string;
    supportRequestData?: SupportRequestData;
    reputationalRiskData?: ReputationalRiskData;
    esgGerlQuizComment?: string;
  };
}

export function getIterationStatusBadge(iterationStatusCode: IterationStatusCode) {
  switch (iterationStatusCode) {
    case IterationStatusCode.CREATED:
      return {
        type: 'active',
        i18n: 'iteration-status.open',
      };
    case IterationStatusCode.REJECTED:
      return {
        type: 'critical',
        i18n: 'iteration-status.rejected',
      };
    case IterationStatusCode.CANCELLED:
      return {
        type: '',
        i18n: 'iteration-status.cancelled',
      };
    case IterationStatusCode.VALIDATED:
      return {
        type: 'positive',
        i18n: 'iteration-status.validated',
      };
    default:
      return iterationStatusCode satisfies never;
  }
}
